import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppConfigProvider } from './context/app-configs-context';
import { AuthProvider } from './context/auth-context';
import { SiteConfigProvider } from './context/site-configs-context';
import App from './App';
import './index.scss';
import { ErrorProvider } from './context/error-context';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <ErrorProvider>
            <AuthProvider>
                <AppConfigProvider>
                    <SiteConfigProvider>
                        <App/>
                    </SiteConfigProvider>
                </AppConfigProvider>
            </AuthProvider>
        </ErrorProvider>
    </React.StrictMode>,
);
